import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react'; // eslint-disable-line import/no-unresolved

export const PrevButton: React.FC<{ theme?: 'black' | 'white'; children: React.ReactNode }> = ({
  theme = 'black',
  children,
}) => {
  const swiper = useSwiper();
  const [isBeginning, setIsBeginning] = useState(true);

  useEffect(() => {
    swiper.on('slideChange', (swipe) => {
      setIsBeginning(swipe.isBeginning);
    });
  }, [swiper]);

  return (
    <button
      onClick={() => swiper.slidePrev()}
      disabled={isBeginning}
      className={classNames('flex size-12 items-center justify-center rounded-full ring-2 ring-inset', {
        'opacity-20': isBeginning,
        'ring-neutrals-black': theme === 'black',
        'ring-white': theme === 'white',
      })}
    >
      {children}
    </button>
  );
};
